import { useState, useEffect } from 'react'
import posthog from 'posthog-js'

export const usePageAccessFeatureFlags = (providerName, providerId) => {
  const [blockedDatesAccess, setBlockedDatesAccess] = useState(false)
  const [advancedPricingAccess, setAdvancedPricingAccess] = useState(false)

  useEffect(() => {
    posthog.setPersonPropertiesForFlags({
      provider_name: providerName,
      provider_id: providerId,
    })

    posthog.onFeatureFlags(() => {
      setBlockedDatesAccess(posthog.isFeatureEnabled('blocked_dates_access'))
      setAdvancedPricingAccess(
        posthog.isFeatureEnabled('advanced_price_access')
      )
    })
  }, [providerName])

  return { blockedDatesAccess, advancedPricingAccess }
}
